export default __webpack_public_path__ + "static/media/info.8757a360.svg";